<template>
  <div v-if="isShow()" id="type-visibility">
    <div class="card">
      <div class="card-body">
        <div class="divide-y">
          <label class="row">
            <span class="col-4">
              <span class="title">Тип видимости</span>
            </span>
            <span class="col-8">
              <select class="form-select" v-model="fields.val" @change="changeItem">
                <option v-for="item in fields.getItems()" :key="item['value']" :value="item['value']">{{ item['name'] }}</option>
              </select>
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive, ref} from "vue"
import "./css/style.css"

export default defineComponent({
  name: "TypeVisibility",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    const fields = reactive({
      val: null,
      items: [
        {
          value: 2,
          name: "Публичный",
        },
        {
          value: 1,
          name: "Приватный",
        },
      ],
      getItems: () => {
        return fields.items
      },
    })

    onMounted(async () => {
      updateFields(props.payload)

      markUnshow()
      markShow()
    })

    function updateFields(query) {
      fields.val = query.val
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changeItem(e) {
      pushEvent(parseInt(e.target.value))
    }

    function pushEvent(val) {
      emit("onChange", val)
    }

    return {
      isShow,
      fields,
      changeItem,
    }
  }
})
</script>

<style scoped>

</style>
